import { gettext } from '@eventbrite/i18n';
import { TicketCard } from '@eventbrite/listings-multitickets';
import { Stack } from '@eventbrite/marmalade';
import React from 'react';
import { useTicketContext } from '../../contexts';
import { useCommunicationDispatch } from '../../contexts/CommunicationContext';
import { useScrollOnCommand } from '../../contexts/ScrollContext';
import { EventDetailsSectionTitle } from '../EventDetails/EventDetails';
import { TicketClass } from './types';
import { useTicketQuantityStore } from './useTicketQuantityStore';
import { shouldShowMultiTicketsSelection } from './utils';

export const Tickets = () => {
    const { ticketData, setTotalTicketsSelected } = useTicketContext();

    const { sendNewQuantities } = useCommunicationDispatch();
    const ticketRef = React.useRef<HTMLDivElement>(null);
    useScrollOnCommand(ticketRef, 'tickets');
    const { ticketClasses, compactCheckoutDisqualifications } = ticketData;

    const { changeQuantity } = useTicketQuantityStore(
        ticketClasses,
        sendNewQuantities,
        setTotalTicketsSelected,
    );

    if (!shouldShowMultiTicketsSelection(compactCheckoutDisqualifications)) {
        return null;
    }

    return (
        <section className="event-details__section" ref={ticketRef}>
            <EventDetailsSectionTitle>
                <h2>{gettext('Tickets')}</h2>
            </EventDetailsSectionTitle>
            <Stack space="spacing-lg" as="ul">
                {ticketClasses.map((ticket: TicketClass, index: number) => {
                    return (
                        <li key={index}>
                            <TicketCard
                                characteristics={ticket.characteristics}
                                onQuantityChange={(ticketClassId, quantity) =>
                                    changeQuantity(ticketClassId, quantity)
                                }
                                cost={ticket.cost}
                                description={ticket.description}
                                displayFlags={ticket.displayFlags}
                                fee={ticket.fee}
                                id={ticket.id}
                                name={ticket.displayName}
                                tax={ticket.tax}
                                quantityRemaining={ticket.quantityRemaining}
                            />
                        </li>
                    );
                })}
            </Stack>
        </section>
    );
};
